/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ThemeVersionsImport } from './routes/theme-versions'
import { Route as MediaLibraryImport } from './routes/media-library'
import { Route as ThemerImport } from './routes/_themer'
import { Route as IndexImport } from './routes/index'
import { Route as ThemerThemerIndexImport } from './routes/_themer/themer.index'
import { Route as ThemerThemerComponentImport } from './routes/_themer/themer.$component'

// Create/Update Routes

const ThemeVersionsRoute = ThemeVersionsImport.update({
  path: '/theme-versions',
  getParentRoute: () => rootRoute,
} as any)

const MediaLibraryRoute = MediaLibraryImport.update({
  path: '/media-library',
  getParentRoute: () => rootRoute,
} as any)

const ThemerRoute = ThemerImport.update({
  id: '/_themer',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ThemerThemerIndexRoute = ThemerThemerIndexImport.update({
  path: '/themer/',
  getParentRoute: () => ThemerRoute,
} as any)

const ThemerThemerComponentRoute = ThemerThemerComponentImport.update({
  path: '/themer/$component',
  getParentRoute: () => ThemerRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_themer': {
      id: '/_themer'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ThemerImport
      parentRoute: typeof rootRoute
    }
    '/media-library': {
      id: '/media-library'
      path: '/media-library'
      fullPath: '/media-library'
      preLoaderRoute: typeof MediaLibraryImport
      parentRoute: typeof rootRoute
    }
    '/theme-versions': {
      id: '/theme-versions'
      path: '/theme-versions'
      fullPath: '/theme-versions'
      preLoaderRoute: typeof ThemeVersionsImport
      parentRoute: typeof rootRoute
    }
    '/_themer/themer/$component': {
      id: '/_themer/themer/$component'
      path: '/themer/$component'
      fullPath: '/themer/$component'
      preLoaderRoute: typeof ThemerThemerComponentImport
      parentRoute: typeof ThemerImport
    }
    '/_themer/themer/': {
      id: '/_themer/themer/'
      path: '/themer'
      fullPath: '/themer'
      preLoaderRoute: typeof ThemerThemerIndexImport
      parentRoute: typeof ThemerImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  ThemerRoute: ThemerRoute.addChildren({
    ThemerThemerComponentRoute,
    ThemerThemerIndexRoute,
  }),
  MediaLibraryRoute,
  ThemeVersionsRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_themer",
        "/media-library",
        "/theme-versions"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_themer": {
      "filePath": "_themer.tsx",
      "children": [
        "/_themer/themer/$component",
        "/_themer/themer/"
      ]
    },
    "/media-library": {
      "filePath": "media-library.tsx"
    },
    "/theme-versions": {
      "filePath": "theme-versions.tsx"
    },
    "/_themer/themer/$component": {
      "filePath": "_themer/themer.$component.tsx",
      "parent": "/_themer"
    },
    "/_themer/themer/": {
      "filePath": "_themer/themer.index.tsx",
      "parent": "/_themer"
    }
  }
}
ROUTE_MANIFEST_END */
